import { type FairsTranslations } from './fairs.translations.pl.ts';

export const fairsTranslations: FairsTranslations = {
  addCandidates: 'Add candidates',
  bulk: {
    addMore: 'Add more',
    cancel: 'Cancel',
    close: 'Close',
    description:
      'Paste the e-mail addresses collected at the stand: one per line or separated by commas or semicolons. You can paste a whole Excel column.',
    emailsLabel: 'E-mail addresses',
    emailsPlaceholder: 'anna.nowak@student.pl\njan.kowalski@university.edu.pl',
    error: 'The candidates could not be added. Please try again.',
    fairHint: 'Candidates with the same job fair name make up one results card.',
    fairLabel: 'Job fair name',
    fairPlaceholder: 'e.g. AGH Job Fair, March 2027',
    found: 'Addresses found: {{count}}',
    result: {
      added: 'Added: {{count}}',
      alreadyAdded: 'Already on the list: {{count}}',
      invalid: 'Not e-mail addresses: {{count}}',
      title: 'Done',
    },
    submit: 'Add to the list',
    title: 'Add job fair candidates',
    tooMany: 'You can add up to {{max}} addresses at once.',
  },
  edit: {
    cancel: 'Cancel',
    emailLabel: 'E-mail address',
    error: 'The changes could not be saved.',
    fairLabel: 'Job fair name',
    save: 'Save',
    success: 'Changes saved.',
    title: 'Edit job fair candidate',
  },
  list: {
    addedBy: 'added by {{name}}',
    allTitle: 'All job fair candidates',
    columns: {
      added: 'Added to the list',
      candidate: 'Candidate',
      fair: 'Job fair',
      registered: 'Registration',
      score: 'Score',
      status: 'Recruitment stage',
    },
    edit: 'Edit',
    empty: 'There are no candidates on this list yet.',
    fairTitle: 'Candidates: {{fair}}',
    notRegistered: 'Not registered',
    openProfile: "Open the candidate's profile",
    profileError: "The candidate's profile could not be opened.",
  },
  results: {
    allFairs: 'All job fairs',
    empty:
      'There are no job fair candidates yet. Add the e-mail addresses collected at the stand to see how many of them joined the recruitment and how many were recommended.',
    funnel: {
      added: 'Added from the fair',
      quizFinished: 'Finished the quiz',
      recommended: 'Recommended',
      registered: 'Registered',
    },
    lastAdded: 'Last added {{date}}',
    noName: 'No job fair name',
    recommendedShare: 'of the fair candidates recommended',
    showCandidates: 'Show candidates',
    title: 'Job fair results',
  },
  subtitle: 'Candidates met at job fairs and how far they got in the recruitment',
  title: 'Job fairs',
};
